import moment from 'moment-timezone';

import TU from 'constants/time/units.const';
import { fromMomentToIso } from 'utils/converters/time/from.util';
import nullBind from 'utils/functions/nullBind.util';
import isNotDateWorthy from 'utils/predicates/time/isNotDateWorthy.util';

// shorter names
const bad = isNotDateWorthy;
const iso = fromMomentToIso;
const m = moment;

// NOTE: keep these "hidden" and use more specialized functions as to have more control over the different values used
const timeAdd = (unit, value, date) => (bad(date) ? '' : iso(m(date).add(value, unit)));
const timeSub = (unit, value, date) => (bad(date) ? '' : iso(m(date).subtract(value, unit)));

// Here are more specialised versions - these have the unit baked into them

export const timeAddYears = nullBind(timeAdd, TU.lg.y);
export const timeAddMonths = nullBind(timeAdd, TU.lg.m);
export const timeAddWeeks = nullBind(timeAdd, TU.lg.w);
export const timeAddDays = nullBind(timeAdd, TU.lg.d);

export const timeAddHours = nullBind(timeAdd, TU.md.h);
export const timeAddMinutes = nullBind(timeAdd, TU.md.m);
export const timeAddSeconds = nullBind(timeAdd, TU.md.s);

export const timeAddMilliseconds = nullBind(timeAdd, TU.sm.m);

export const timeSubMonths = nullBind(timeSub, TU.lg.m);
export const timeSubWeeks = nullBind(timeSub, TU.lg.w);
export const timeSubDays = nullBind(timeSub, TU.lg.d);

export const timeSubHours = nullBind(timeSub, TU.md.h);
export const timeSubMinutes = nullBind(timeSub, TU.md.m);

// Here are the most specialised functions as they only accept the date with unit and value already fixed

export const timeAdd01year = nullBind(timeAddYears, 1);
export const timeAdd07days = nullBind(timeAddDays, 7);

export const timeSub03days = nullBind(timeSubDays, 3);
export const timeSub07days = nullBind(timeSubDays, 7);

export const timeAdd15min = nullBind(timeAddMinutes, 15);
export const timeAdd30min = nullBind(timeAddMinutes, 30);
export const timeAdd45min = nullBind(timeAddMinutes, 45);
export const timeAdd60min = nullBind(timeAddMinutes, 60);

export const timeSub15min = nullBind(timeSubMinutes, 15);
export const timeSub30min = nullBind(timeSubMinutes, 30);
export const timeSub45min = nullBind(timeSubMinutes, 45);
export const timeSub60min = nullBind(timeSubMinutes, 60);

export const timeAdd02hrs = nullBind(timeAddHours, 2);
export const timeSub02hrs = nullBind(timeSubHours, 2);

export const timeAdd1Month = nullBind(timeAddMonths, 1);
export const timeSub1Month = nullBind(timeSubMonths, 1);

export const timeAdd1Week = nullBind(timeAddWeeks, 1);
export const timeSub1Week = nullBind(timeSubWeeks, 1);

export const timeAdd1Day = nullBind(timeAddDays, 1);
export const timeSub1Day = nullBind(timeSubDays, 1);
